import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_rxhwf7mn3y: FaireCollectionEntity = {
  token: "pbc_rxhwf7mn3y",
  type: "collection",
  name: "SS26",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1103eca77fb93875cd5d58d7edae7853199b43b3c8b09176b390d6af4c4d27f7.jpeg",
  itemCount: 11,
  description:
    "Spring ’26 is all about easy sandals and standout heels made for warmer days. Shop the collection now. \nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:30.239Z",
    importedBy: "entity-db-import-collections",
  },
};
